exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".can-remove:hover:after{border-radius:3px 12px 3px 3px;content:\"V\"!important;background-color:#c3002f}", "", {"version":3,"sources":["/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/attachment/attachment.component.css"],"names":[],"mappings":"AAAA,wBACE,+BAAgC,sBACJ,wBACF,CAC3B","file":"attachment.component.css","sourcesContent":[".can-remove:hover::after {\n  border-radius: 3px 12px 3px 3px;\n  content: '\\0056' !important;\n  background-color: #c3002f;\n}\n"],"sourceRoot":""}]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/attachment/attachment.component.css
// module id = z++b
// module chunks = 0